/* eslint-disable */
import BASE_URL from '@/services/axios'
import { types } from '@/store/purchase/mutations'

export const GETPURCHASEORDER = async ({ commit, dispatch, rootState }, { page = 1, limit = 20, q = null, from_date, to_date } = {}) => {
  try {
    commit(types.SET_LOADING, true)
    const { data: response } = await BASE_URL({
      method: 'get',
      url: '/po/private/order',
      params: {
        page,
        limit,
        q,
        from_date,
        to_date,
      },
    })
    commit(types.SET_PAGINATION, {
      page,
      limit,
      totalRows: response.total_record,
    })
    commit(types.SET_PURCHASE_ORDER, response.data)
    commit(types.SET_SUM_TOTAL_PURCHASE, {
      subTotal: response.sum_subtotal,
      totalValue: response.sum_totalval,
    })
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(types.SET_LOADING, false)
  }
}

export const GETPRODUCTLISTPURCHASE = async ({ commit, rootState }, { page = 1, limit = 35, sort, order, search_query, channel_id }) => {
  try {
    commit(types.SET_LOADING, true)
    const { data: response } = await BASE_URL({
      method: 'get',
      url: `/products/private/catalog/channel/${channel_id}`,
      params: {
        page,
        limit,
        sort,
        order,
        search_query,
      },
    })
    commit(types.SET_PRODUCT_LIST_PURCHASE, response.data)
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(types.SET_LOADING, false)
  }
}

export const GETCOURIER = async ({ commit }) => {
  try {
    commit(types.SET_LOADING, true)
    const { data: response } = await BASE_URL({
      method: 'get',
      url: '/po/private/courier',
    })
    commit(types.SET_COURIER, response.data)
    return Promise.resolve(response)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(types.SET_LOADING, false)
  }
}

export const GETPAYMENTMETHOD = async ({ commit }) => {
  try {
    commit(types.SET_LOADING, true)
    const { data: response } = await BASE_URL({
      method: 'get',
      url: '/po/private/payment-method',
    })
    commit(types.SET_PAYMENT_METHOD, response.data)
    return Promise.resolve(response)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(types.SET_LOADING, false)
  }
}

export const GETRATE = async ({ commit }, { weight = 100, total, courier }) => {
  try {
    commit(types.SET_LOADING, true)
    const { data: response } = await BASE_URL({
      method: 'post',
      url: '/po/private/rate',
      data: {
        weight,
        total,
        courier,
      },
    })
    return Promise.resolve(response)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(types.SET_LOADING, false)
  }
}

export const GETPONUMBER = async ({ commit }) => {
  try {
    commit(types.SET_LOADING, true)
    const { data: response } = await BASE_URL({
      method: 'get',
      url: '/po/private/po_number',
    })
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(types.SET_LOADING, false)
  }
}

export const CREATEPO = async ({ commit, dispatch }, {
  warehouse_data,
  transaction_data,
  po_items,
  courier,
  po_number,
  shipping_data,
  billing_data,
  is_po_generator,
}) => {
  try {
    commit(types.SET_LOADING, true)
    const { data: response } = await BASE_URL({
      method: 'post',
      url: '/po/private',
      data: {
        po_number,
        is_po_generator,
        transaction_data,
        shipping_data,
        warehouse_data,
        courier,
        billing_data,
        po_items,
      },
    })
    // console.log(response, 'its response')
    commit(types.SET_CREATE_SUCCESS, response.data)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(types.SET_LOADING, false)
  }
}

export const GETUSERBILLINGADDRESS = async ({ commit, dispatch }, { addr_key }) => {
  try {
    commit(types.SET_LOADING, true)
    const { data: response } = await BASE_URL({
      method: 'get',
      url: '/users/private/seller/address',
      params: {
        addr_type: 'billing',
        addr_key: addr_key === 'last' ? 'last' : 'all',
      },
    })
    // console.log(response.data)
    if (addr_key === 'last') {
      commit(types.SET_LAST_BILLING_ADDRESS, response.data[0])
    } else if (addr_key === 'all') {
      commit(types.SET_ALL_BILLING_ADDRESS, response.data)
    }
    if (!response.data || (response.data && !response.data.length)) {
      return Promise.resolve({
        data: response.data,
        isHaveLastBillAddress: false,
      })
    } else {
      return Promise.resolve({
        data: response.data,
        isHaveLastBillAddress: true,
      })
    }
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(types.SET_LOADING, false)
  }
}

export const GETUSERSHIPPINGADDRESS = async ({ commit, dispatch }, { addr_key }) => {
  try {
    commit(types.SET_LOADING, true)
    const { data: response } = await BASE_URL({
      method: 'get',
      url: '/users/private/seller/address',
      params: {
        addr_type: 'shipping',
        addr_key: addr_key === 'last' ? 'last' : 'all',
      },
    })
    if (addr_key === 'last') {
      commit(types.SET_LAST_SHIPPING_ADDRESS, response.data[0])
    } else if (addr_key === 'all') {
      commit(types.SET_ALL_SHIPPING_ADDRESS, response.data)
    }
    if (!response.data || (response.data && !response.data.length)) {
      return Promise.resolve({
        data: response.data,
        isHaveLastShippAddress: false,
      })
    } else {
      return Promise.resolve({
        data: response.data,
        isHaveLastShippAddress: true,
      })
    }
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit(types.SET_LOADING, false)
  }
}

export const GETPURCHASEDETAIL = async ({ commit }, { order_number }) => {
  try {
    commit(types.SET_LOADING, true)
    const { data: response } = await BASE_URL({
      method: 'get',
      url: `/po/private/orderdetail/${order_number}`
    })
    // console.log(response)
    commit(types.SET_CREATE_SUCCESS, response.data)
    return Promise.resolve(response)
  } catch (error) {
    return Promise.resolve(error)
  } finally {
    commit(types.SET_LOADING, false)
  }
}
